import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export function trackTopNavigationClicked(linkText: string) {
  trackEvent(keys.categoryNavigation, {
    'menu-position': 'top',
    cn_target: linkText,
  })
}

export function trackBottomNavigationClicked(linkText: string) {
  trackEvent(keys.categoryNavigation, {
    'menu-position': 'bottom',
    cn_target: linkText,
  })
}
